import { RolesEnumList } from '../enums/roles-columns';
import { RolesColumnConfig } from '../interfaces/column-config.interface';

export const ROLES_SETTINGS = {
  pageSizes: [5, 10, 25, 50],
  itemsPerPage: 10,
  currentPage: 1,
};

export const FAKE_ROLES_QUANTITY = 5;

export const ROLES_TABLE_HEADER_LABELS = 'shop-settings.roles.table';

export const ROLES_COLUMNS_CONFIG: readonly RolesColumnConfig[] = [
  {
    name: RolesEnumList.NAME,
    label: `${ROLES_TABLE_HEADER_LABELS}.role`,
    headerClass: 'header-cell header-cell--name',
    cellClass: 'cell',
  },
  {
    name: RolesEnumList.DESCRIPTION,
    label: `${ROLES_TABLE_HEADER_LABELS}.description`,
    headerClass: 'header-cell header-cell--description',
    cellClass: 'cell',
  },
  {
    name: RolesEnumList.USERS,
    label: `${ROLES_TABLE_HEADER_LABELS}.numberOfUsers`,
    headerClass: 'header-cell header-cell--users',
    kind: 'users',
  },
  {
    name: RolesEnumList.ACTIONS,
    label: `${ROLES_TABLE_HEADER_LABELS}.actions`,
    headerClass: 'header-cell header-cell--actions',
    kind: 'actions',
  },
];

export const ROLES_OPTIONS = {
  width: '600px',
  maxWidth: '95vw',
  panelClass: 'no-radius-dialog',
};
